module.exports = __webpack_public_path__ + "84cbca5d23482bf38f806581a655fb8a.svg";